import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LandingPage from '../pages/Landing';
import DashboardPage from '../pages/Dashboard';
import LoginPage from '../pages/Login';
import TransferPage from '../pages/Transfer';
import SignUpPage from '../pages/SignUp';
import TransferHistoryPage from '../pages/TransferHistory';
import OperationsPage from '../pages/Operations';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/landing" element={<LandingPage />} />
    <Route path="/dashboard" element={<DashboardPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/transfer" element={<TransferPage />} />
    <Route path="/sign-up" element={<SignUpPage />} />
    <Route path="/SignUp" element={<SignUpPage />} />
    <Route path="/transfer-history" element={<TransferHistoryPage />} />
    <Route path="/TransferHistory" element={<TransferHistoryPage />} />
    <Route path="/operations" element={<OperationsPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRoutes;
